import './HtmlTextInput.scss'
import { isEmpty } from '../../Utils/Validations'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

interface HtmlTextInputProps {
  value?: string
  onChange?: (newValue: string) => void
  label?: string
  helperText?: string
  placeholder?: string
  isValid?: boolean
  isReadOnly?: boolean
}

export function HtmlTextInput({
  value,
  onChange,
  label,
  helperText,
  placeholder,
  isValid,
  isReadOnly,
}: HtmlTextInputProps) {
  return (
    <div
      className={`html-text-input ${isValid === false ? 'invalid' : ''} ${
        isReadOnly ?? false ? 'is-read-only' : ''
      }`}
    >
      {!isEmpty(label) ? <div className="input-label">{label}</div> : null}

      <ReactQuill
        className="input-element"
        theme="snow"
        value={value}
        onChange={(value) => {
          if (onChange) {
            onChange(value)
          }
        }}
        placeholder={placeholder}
        readOnly={isReadOnly}
        modules={modules}
        formats={formats}
      />
      {!isEmpty(helperText) ? (
        <div className="input-helper-text">{helperText}</div>
      ) : null}
    </div>
  )
}

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
}

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
]
